import {findIndex} from 'lodash';
import createReducer from '../../common/util/createReducer';
import {MasterVehicle, Common} from '../../common/actionTypes';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'pageSize': 20,
  'pageNumber': 0,
  'itemsCount': 0,
  'externalColors': [],
  'loadingOrdersByChassis': false,
  'ordersByChassis': [],
  'updating': false,
};

function updateStatusInList(list, vehicleData) {
  const newList = [...list];
  const index = findIndex(newList, {'chassis': vehicleData.chassis});

  const newObject = {...newList[index]};
  newObject.status = vehicleData.status;

  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
}

export const vehiclesAvailability = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_VEHICLES_AVAILABILITY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLES_AVAILABILITY]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'itemsCount': action.response.count,
    }),
    [ActionTypes.FETCHED_VEHICLES_AVAILABILITY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'itemsCount': 0,
    }),
    [MasterVehicle.FETCHED_JDE_PARAMETERS]: (state, action) => ({
      ...state,
      'externalColors': action.response.data.outdoorColorList,
    }),
    [MasterVehicle.FETCHED_JDE_PARAMETERS_FAILED]: (state, action) => ({
      ...state,
      'externalColors': [],
    }),
    [Common.CHANGE_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
    }),
    [Common.CHANGE_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
    }),
    [ActionTypes.FETCHING_ORDERS_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loadingOrdersByChassis': true,
    }),
    [ActionTypes.FETCHED_ORDERS_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loadingOrdersByChassis': false,
      'ordersByChassis': action.response.data,
    }),
    [ActionTypes.FETCHED_ORDERS_BY_CHASSIS_FAILED]: (state, action) => ({
      ...state,
      'loadingOrdersByChassis': false,
      'ordersByChassis': [],
    }),
    [ActionTypes.UPDATING_AVAILABILITY_IN_VEHICLE]: (state, action) => ({
      ...state,
      'updating': true,
    }),
    [ActionTypes.UPDATED_AVAILABILITY_IN_VEHICLE]: (state, action) => ({
      ...state,
      'updating': false,
      'list': [...updateStatusInList(state.list, action.response.data)],
    }),
    [ActionTypes.UPDATED_AVAILABILITY_IN_VEHICLE_FAILED]: (state, action) => ({
      ...state,
      'updating': false,
    }),
  })(state, action);
};
